var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product.Id)?_c('div',{staticClass:"item-cells price"},[(_vm.isStepOrder)?_c('PriceStep',{attrs:{"product":_vm.product,"order":_vm.order}}):_c('PriceCommon',{attrs:{"product":_vm.product,"order":_vm.order}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }